import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=678a39d6&scoped=true"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=678a39d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678a39d6",
  null
  
)

export default component.exports